import React, { useEffect, useState } from "react";

import Space from "../../layout/Space";
import PrimaryButton from "../../buttons/PrimaryButton";
import sendVerificationEmail from "../../api/send/sendVerificationEmail.js";

import { logoutUser, useAuth } from "../../auth/FirebaseAuth";

import { useSnackbar } from "notistack";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";
import sendPasswordResetEmail from "../../api/send/sendPasswordEmail.js";
import Modal1 from "../../modals/Modal1.js";
import SecondaryButton from "../../buttons/SecondaryButton";

import { useAppContext } from "../../config/AppContext.js";

import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi.js";

import ImageCropper from "../../images/ImageCropper.js";
import uploadProfilePictureFromBlob from "../../api/upload/uploadProfilePictureFromBlob.js";

import TextField2T from "../../textfields/TextField2T";
import SmsModalEmail from "../../portal/SmsModalEmail.js";
import { User } from "../../types/user.js";
import { Org } from "../../types/org.js";

// Account Component
type AccountProps = {
  userData: User; // Replace 'any' with a more specific type if available
  orgData?: Org;
  navigateWorkspace: (path: string) => void;
  overrideId?: string;
  masterData?: Org | null;
};

function Account({
  userData,
  orgData,
  navigateWorkspace,
  overrideId,
  masterData,
}: AccountProps) {
  const { currentUser, loading } = useAuth();

  const [nom, setNom] = useState("");
  const [email, setEmail] = useState("Email");
  const [phone, setPhone] = useState("");

  const [token, setToken] = useState(null); // Store the token here
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (
    message: string,
    variant: "success" | "error" | "default" | "warning" | "info" | undefined
  ) => {
    enqueueSnackbar(message, { variant });
  };

  const { appState, setAppState, resetAppStateLogin } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const fetchData = async () => {
    if (overrideId) {
      if (orgData?.facturation?.plan !== "free") {
        navigateWorkspace(`/home`);
      } else {
        navigateWorkspace(`/organisation`);
      }
      return;
    }
    if (userData) {
      try {
        setToken(token);
        setNom(userData.display_name || "");
        setEmail(userData.email || "Email");
        setPhone(userData.phone_number || "");
      } catch (error) {
        console.error(
          "Erreur lors de la récupération de l'organisation:",
          error
        );
      }
    }
  };

  const [image, setImage] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [smsOpen, setSmsOpen] = useState(false);
  const handleImageUpload = (e: any) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => setImage(reader.result as any);
      reader.readAsDataURL(file);
    }
  };
  // Fetch the token asynchronously using useEffect
  useEffect(() => {
    fetchData(); // Call the function
  }, [currentUser]); // Run this effect only when currentUser changes

  const callModifyUser = async () => {
    try {
      const token = await getOrRefreshFirebaseToken();
      await updateDocDataFieldApi(userData.ref, "display_name", nom, prefix);
      handleClickVariant("Utilisateur modifié avec succès", "success");
    } catch (error) {
      console.error("Error modifying user:", error);
      handleClickVariant(
        "Erreur lors de la modification de l'utilisateur",
        "error"
      );
    }
  };

  const handleSave = async () => {
    await updateDocDataFieldApi(userData.ref, "phone_number", phone, prefix);
    handleClickVariant("Numéro de téléphone enregistré", "success");
    setSmsOpen(false);
  };

  const handleSendVerificationEmail = async () => {
    try {
      const token = await getOrRefreshFirebaseToken();
      await sendVerificationEmail(token, prefix);
      handleClickVariant("Email de vérification envoyé", "success");
    } catch (error) {
      console.error("Error sending verification email:", error);
      handleClickVariant("Erreur lors de l'envoi de l'email", "error");
    }
  };
  const handleChangePhoto = async (cropped: any) => {
    const token = await getOrRefreshFirebaseToken();
    // await updateDocDataFieldApi(userData.ref, "photo", cropped, prefix);
    await uploadProfilePictureFromBlob(userData.id, cropped, token, prefix);
    handleClickVariant("Photo  modifié avec succès", "success");
    setPhotoOpen(false);
  };

  const handleSendPasswordResetEmail = async () => {
    try {
      const token = await getOrRefreshFirebaseToken();
      await sendPasswordResetEmail(token, prefix);
      handleClickVariant("Email de réinitialisation envoyé", "success");
    } catch (error) {
      console.error("Error sending password reset email:", error);
      handleClickVariant("Erreur lors de l'envoi de l'email", "error");
    }
  };

  const [phonevalue = "", setPhoneValue] = useState("");
  const [code, setCode] = useState("");
  const [step = 0, setStep] = useState(0);
  const [photoOpen, setPhotoOpen] = useState(false);

  if (!userData) {
    return <div></div>;
  }
  return (
    <div className="flex flex-row gap-1 w-full h-full overflow-auto pb-20">
      <Modal1 isOpen={smsOpen} onClose={() => setSmsOpen(false)}>
        <SmsModalEmail
          userData={userData}
          handleSuccess={handleSave}
          setOpen={setSmsOpen}
        ></SmsModalEmail>
      </Modal1>
      <Modal1 isOpen={photoOpen} onClose={() => setPhotoOpen(false)}>
        <div className="bg-white w-c500 flex flex-col p-4 rounded-3xl gap-3  ">
          <div className="text-h1 font-normal">Photo de profil</div>
          <Space y={5} />
          <div>
            {userData.photo && !image && (
              <img
                src={userData.photo}
                className="h-32 w-32 object-cover rounded-full"
              />
            )}
          </div>
          <div>
            {!userData.photo && (
              <div className="h-32 w-32 min-h-32 min-w-32 object-cover rounded-full  bg-red-100">
                <img
                  src={
                    "https://upload.wikimedia.org/wikipedia/commons/a/ac/Default_pfp.jpg?20200418092106"
                  }
                  className="h-32 w-32 object-cover border-1 border-red-500 rounded-full "
                />
              </div>
            )}
          </div>
          <div className="rounded-full h-12 w-12 flex flex-row items-center cursor-pointer">
            <input type="file" accept="image/*" onChange={handleImageUpload} />
          </div>

          <div>
            {image && (
              <ImageCropper
                imageSrc={image}
                onCropComplete={(cropped: any) => handleChangePhoto(cropped)}
              />
            )}
          </div>
        </div>
      </Modal1>

      <div className="flex flex-col  h-full max-w-c500 pl-4 ">
        <div className="flex flex-row justify-between w-full">
          <div className="text-h1 font-bold text-left">Compte</div>{" "}
          <div className="text-h5 text-shadow_10">user_id {userData.id}</div>
        </div>
        <Space y={20} />
        <div className="text-h2 font-normal">Photo de profil</div>
        <Space y={5} />
        <div
          className="rounded-full h-12 w-12 flex flex-row items-center cursor-pointer"
          onClick={() => setPhotoOpen(true)}
        >
          {userData.photo && (
            <img
              src={userData.photo}
              className="h-12 w-12 object-cover rounded-full hover:shadow-lg"
            />
          )}
          {!userData.photo && (
            <div className="h-12 w-12 object-cover rounded-full  bg-red-100">
              <img
                src={
                  "https://upload.wikimedia.org/wikipedia/commons/a/ac/Default_pfp.jpg?20200418092106"
                }
                className="h-12 w-12 object-cover border-1 border-red-500 rounded-full hover:shadow-lg"
              />
            </div>
          )}
        </div>

        <Space y={20} />

        <div className="flex  w-full text-h2 font-normal">
          <SecondaryButton onClick={handleSendVerificationEmail}>
            Envoyer un email de vérification
          </SecondaryButton>
        </div>
        <Space y={10} />
        <div className="flex  w-full text-h2 font-normal">
          <SecondaryButton
            onClick={handleSendPasswordResetEmail}
            className="w-fit"
          >
            Envoyer un mail de réinitialisation de mot de passe
          </SecondaryButton>
        </div>
        <Space y={30} />
        <div className="flex flex-col gap-1 w-full pr-2">
          <TextField2T
            className="w-full"
            label="ID"
            value={userData.id}
            disabled={true}
          />
          <TextField2T
            className="w-full"
            label="Email"
            value={userData.email}
            disabled={true}
          />
          <TextField2T
            className="w-full"
            label="Prénom Nom"
            value={nom}
            onChange={(e: any) => setNom(e.target.value)}
          />
        </div>
        <Space y={5} />
        <div className="flex flex-col gap-1 w-full pr-2">
          <div className="flex justify-end w-full text-h2 font-normal">
            <PrimaryButton
              onClick={callModifyUser}
              disabled={
                userData?.display_name ? nom === userData?.display_name : false
              }
            >
              Enregistrer
            </PrimaryButton>
          </div>
        </div>
        <Space y={10} />
        <div className="flex flex-col gap-1 w-full pr-2">
          <TextField2T
            className="w-full"
            label="Téléphone personnel (sécurité sms)"
            value={phone}
            mandatory={true}
            onChange={(e) => setPhone(e.target.value)}
            type="phone"
          />
        </div>
        <Space y={5} />
        <div className="flex flex-col pb-20 w-full pr-2">
          <div className="flex justify-end w-full text-h2 font-normal">
            <PrimaryButton
              disabled={phone === userData?.phone_number}
              onClick={() => setSmsOpen(true)}
            >
              Enregistrer le numéro de télephone
            </PrimaryButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Account;
